<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup class=" ml-5 content-center">
          <CCard class="p-3">
            <CCardBody>
              <form class="login" @submit.prevent="changePassword">
                <h1>Account Deletion</h1>
                <p class="text-muted">Fill Email and Password to delete your account</p>
                <!-- Add an email input field -->
                <CInput
                  placeholder="Email"
                  type="email"
                  autocomplete="email"
                  v-model="data.email"
                  required
                >
                  <template #prepend-content><CIcon name="cil-envelope-closed"/></template>
                </CInput>

                <!-- Password input field -->
                <CInput
                  placeholder="Password"
                  type="password"
                  autocomplete="current-password"
                  v-model="data.password"
                  required
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>

                <!-- Password confirmation input field -->
                <CInput
                  placeholder="Password Confirmation"
                  type="password"
                  autocomplete="current-password-confirmation"
                  v-model="data.password_confirmation"
                  required
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>

                <hr>
                <CRow>
                  <CCol class="text-left">
                    <p class="text-danger" v-if="data.error">{{ data.error }}</p>
                    <!-- Change the method to "changePassword" and remove the "v-on:click.prevent" -->
                    <CButton block type="submit" color="info" class="mt-3">Delete Account</CButton>
                  </CCol>
                </CRow>
              </form>
            </CCardBody>
          </CCard>

        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
    data(){
        return{
            data: {

            },
        }
    },
    created() {

    },
    computed: {

    },
    methods: {

    }
}
</script>
